const planosBeneficiosStore = {
  namespaced: true,
  state: {
    planos_beneficios: [
      {
        icone: "mdi-hand-heart-outline",
        descricao: "Plano de Saúde",
        rota: "plano-saude",        
      },
      {
        icone: "mdi-tooth-outline",
        descricao: "Plano Odontológico",
        rota: "",  
        tipo_arquivo: "pdf",              
        url: "https://www.coasul.com.br/colaborador/planos-beneficios/plano-odonto.pdf"    
      },
      {
        icone: "mdi-shield-account-outline",
        descricao: "Seguro de Vida",
        rota: "",
        tipo_arquivo: "img",        
        url: "https://www.coasul.com.br/colaborador/planos-beneficios/seguro-de-vida.jpeg"
      },
    ],
  },
  mutations: {},
  actions: {},
  getters: {},
};

export default planosBeneficiosStore;
